import React from 'react'

export const useDocumentCardHandlers = (
  isChecked: boolean,
  onCheckmarkClick?: (checked: boolean) => void,
  onRenameClick?: () => void,
  onRemove?: () => void
) => {
  const handleCheckmarkClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onCheckmarkClick?.(!isChecked)
  }

  const handleRemoveClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onRemove?.()
  }

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault()
    onRenameClick?.()
  }

  return { handleCheckmarkClick, handleRemoveClick, handleEditClick }
}
